<div>
    <div [hidden]="!subscriptionLoaded || subscription">
        <div class="message info" i18n="@@apps.apiportal.api.message.no-subscription-available" test-id="apps.apiportal.api.info.text">There is no API portal
            subscription available for this tenant!</div>
    </div>

    <div [hidden]="!subscriptionLoaded">
        <clx-row type="buttons">
            <clx-button
                class="default"
                test-id="apps.apiportal.api.copyprimarykey.button"
                title="Copy primary api key to clipboard"
                i18n-title="@@apps.apiportal.api.title.copyprimarykey"
                (click)="copyKey(true)"
            >
                <span [class]="'fa fa-' + (primaryKeyCopied ? 'check' : 'copy')"></span>
                <label i18n="@@apps.apiportal.api.label.copyprimarykey">Copy primary API key</label>
            </clx-button>
            <clx-button
                class="default"
                test-id="apps.apiportal.api.copysecondarykey.button"
                title="Copy secondary api key to clipboard"
                i18n-title="@@apps.apiportal.api.title.copysecondarykey"
                (click)="copyKey(false)"
            >
                <span [class]="'fa fa-' + (secondaryKeyCopied ? 'check' : 'copy')"></span>
                <label i18n="@@apps.apiportal.api.label.copysecondarykey">Copy secondary api key</label>
            </clx-button>
            <clx-button
                class="default"
                test-id="apps.apiportal.api.download.button"
                title="download"
                i18n-title="@@apps.apiportal.api.button.download"
                (click)="download()"
            >
                <span class="fa fa-download"></span>
                <label  i18n="@@apps.apiportal.api.label.api-definition">Api definition</label>
            </clx-button>
        </clx-row>

        <div id="swagger-ui"></div>
    </div>
</div>